import { useNavigate } from 'react-router-dom'

import Login from 'src/ui/templates/Login'
import Button from 'src/ui/atoms/Button'

const Welcome = () => {
  const navigate = useNavigate()

  return (
    <Login>
      <div className="flex h-full flex-col justify-between">
        <h2 className="text-white">ZoidCore</h2>
        <h1 className="text-3xl leading-[88px] text-white">
          Build a{' '}
          <span className="bg-gradient-to-r from-cyber-pink to-main-blue bg-clip-text text-transparent">
            Web 3.0 universe
          </span>{' '}
          the easy way
        </h1>
        <div className="grid grid-flow-col gap-6">
          <Button name="Sign up" onClick={() => navigate('/register')} dataCy="sign-up" />
          <Button
            name="Login"
            type="secondary"
            onClick={() => navigate('/login')}
            data-cy="login"
          />
        </div>
      </div>
    </Login>
  )
}

export default Welcome
